function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 28,
  rx: 14,
  fill: "#174ABC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.25 14.375C22.25 10.0247 18.7253 6.5 14.375 6.5C10.0247 6.5 6.5 10.0247 6.5 14.375C6.5 18.3055 9.37977 21.5635 13.1445 22.1547V16.6514H11.144V14.375H13.1445V12.64C13.1445 10.6664 14.3194 9.57633 16.1189 9.57633C16.9807 9.57633 17.8819 9.73002 17.8819 9.73002V11.667H16.8886C15.9106 11.667 15.6055 12.2742 15.6055 12.8968V14.375H17.7895L17.4402 16.6514H15.6055V22.1547C19.3702 21.5635 22.25 18.3055 22.25 14.375Z",
  fill: "white"
});

function SvgFooterIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon4);
export default __webpack_public_path__ + "static/media/footer_icon4.b2cf311e.svg";
export { ForwardRef as ReactComponent };